import { createSlice } from "@reduxjs/toolkit";
import { createFacility, getFacilityById, searchFacilities, updateFacility } from "../api/facility";


interface FacilityState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as FacilityState;
 export const facilitySlice = createSlice({
    name: 'facility',
    initialState,
    reducers:{
        resetparty: () => initialState,
      },
    extraReducers(builder) {
        builder
          .addCase(createFacility.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(createFacility.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(createFacility.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(updateFacility.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(updateFacility.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(updateFacility.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(searchFacilities.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(searchFacilities.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(searchFacilities.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
          .addCase(getFacilityById.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(getFacilityById.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(getFacilityById.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
    }
 })

 export const { resetparty } = facilitySlice.actions;

export default facilitySlice.reducer;
